import { useEffect, useState, useRef } from "react";
import './ProductSliderMulti.scss';
import { ReactComponent as HeartImg } from '../assets/heart.svg';
import heartImg from '../assets/heart.svg';
import { UseInterval } from "../UseInterval";
import { useNavigate } from "react-router-dom";
import newTag from '../assets/new.svg'
import { IoCartOutline, IoCheckmark } from "react-icons/io5";
import axios from "axios";
import { useProfile } from "../../../Contexts/ProfileContext";
import { useToast } from "../../../Contexts/ToastContext";

export function ProductSliderMultiMob({ slides }) {
    const [isHover, setIsHover] = useState(-1)
    const [addingToWishlist, setAddingToWishlist] = useState(null);
    const [addingToCart, setAddingToCart] = useState(null);
    const [addedToCart, setAddedToCart] = useState(null);
    const [addedToWishlist, setAddedToWishlist] = useState(null);
    const [pincode, setPincode] = useState('110001'); // Default pincode

    const navigate = useNavigate();
    const { fetchProfile } = useProfile();
    const { showToast } = useToast();
    const mainMultiRefs = useRef({});
    const hoverIndexRef = useRef(isHover);
    hoverIndexRef.current = isHover;

    useEffect(() => {
        const onResize = () => {
            const idx = hoverIndexRef.current;
            const el = idx >= 0 && mainMultiRefs.current[idx];
            if (el) {
                el.style.width = '';
                requestAnimationFrame(() => {
                    const w = el.getBoundingClientRect().width;
                    el.style.width = Math.round(w) + 'px';
                });
            }
        };
        window.addEventListener('resize', onResize);
        return () => window.removeEventListener('resize', onResize);
    }, []);

    const imagesToShow = 1
    const SLIDE_WIDTH_PX = 210; // fixed px: no % so no rounding gap from transform
    const [slideXPos, setSlideXPos] = useState(-(imagesToShow - 1));
    const movePercent = (100 / imagesToShow).toFixed(5)
    const tr = (x) => `translateX(${x}) translateZ(0)`;
    const trPx = (n) => tr(`${n * SLIDE_WIDTH_PX}px`);
    const [swichSlides, setSwichSlides] = useState({ transform: trPx(slideXPos), transition: 'all 0s linear' });
    const [activeSmalldots, setActiveSmalldots] = useState(0)
    let [delay, setDelay] = useState(null);


    let [imagesCount, setImagesCount] = useState(null)

    useEffect(() => {
        if (swichSlides.transition === '' && delay === null) {
            setSwichSlides({ transform: trPx(0), transition: 'none' });
            setSlideXPos(0)
        }
        else if (swichSlides.transition === '') {
            setSwichSlides({ transform: trPx(slideXPos), transition: 'none' });
            setDelay(10);
            setSlideXPos(0)
        }
    }, [swichSlides])

    useEffect(() => {
    }, [delay])

    function swichSlideXPos() {
        if (slideXPos === -(imagesCount)) {
            setSwichSlides({ transform: trPx(-(imagesToShow - 1)), transition: '' })
            setSlideXPos(-(imagesToShow - 1));

        }
        else {
            setSwichSlides({ transform: trPx(slideXPos - 1), transition: 'all 1s linear' });
            setSlideXPos(slideXPos - 1);
            setActiveSmalldots(activeSmalldots + 1);
        }

        if (Object.is(slideXPos, -(imagesCount - 1))) {
            setActiveSmalldots(0);
        }
    }

    UseInterval(() => {
        if (delay === 500) {
            setDelay(1500);
        }
        else if (delay === 10) {
            setDelay(1500);
        }
        swichSlideXPos();
    }, delay);

    function handleDelayChange(images) {
        setDelay(500);
        setImagesCount(images)
    }

    function unsetHover() {
        setDelay(null);
        setSwichSlides({ transform: trPx(0), transition: '' })
        setIsHover(-1);
        setActiveSmalldots(0);
    }

    const MIN_LOADER_MS = 400;

    // Add to cart function
    const handleAddToCart = async (product, event) => {
        event.stopPropagation();
        const startedAt = Date.now();
        const productId = product.id;

        try {
            setAddingToCart(productId);

            const isGuest = localStorage.getItem('guestUser') === 'true';
            if (isGuest) {
                const guestCart = JSON.parse(localStorage.getItem('guestCart') || '[]');
                const existingIndex = guestCart.findIndex((item) => String(item.product_id) === String(productId));
                if (existingIndex >= 0) {
                    guestCart[existingIndex].selectedQty = (guestCart[existingIndex].selectedQty || 1) + 1;
                } else {
                    guestCart.push({
                        _id: `guest-cart-${Date.now()}-${productId}`,
                        product_id: productId,
                        urls: product.urls || [],
                        title: product.title || 'Product',
                        price: product.price,
                        brand: product.brand,
                        mrp: product.mrp,
                        selectedSize: 'M',
                        selectedQty: 1,
                        size: { M: 10 },
                        availableSizes: ['M'],
                        availableQuantities: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
                        maxStock: 10
                    });
                }
                localStorage.setItem('guestCart', JSON.stringify(guestCart));
                window.dispatchEvent(new CustomEvent('guestCartUpdated'));
                setAddedToCart(String(productId));
                setTimeout(() => setAddedToCart(null), 3000);
                setAddingToCart(null);
                return;
            }

            const token = localStorage.getItem("token");
            if (!token) {
                showToast({
                    message: 'Please login to add items to cart',
                    variant: 'info',
                    action: { label: 'Login', onClick: () => navigate('/auth/login') },
                });
                return;
            }

            const config = { headers: { Authorization: `Bearer ${token}` } };
            const response = await axios.post(
                `/cart/${productId}`,
                { "selectedSize": "M", "selectedQty": 1, "pincode": pincode },
                config
            );
            setAddedToCart(String(productId));
            setTimeout(() => setAddedToCart(null), 3000);
            try { await fetchProfile(); } catch (e) { console.error('Failed to refetch profile:', e); }
            
        } catch (error) {
            console.error("Failed to add to cart:", error);
            showToast({ message: 'Failed to add item to cart. Please try again.' });
        } finally {
            const elapsed = Date.now() - startedAt;
            const delay = Math.max(0, MIN_LOADER_MS - elapsed);
            if (delay > 0) setTimeout(() => setAddingToCart(null), delay);
            else setAddingToCart(null);
        }
    };

    const handleAddToWishlist = async (product, event) => {
        event.stopPropagation();
        const startedAt = Date.now();
        const productId = product.id;

        try {
            setAddingToWishlist(productId);

            const isGuest = localStorage.getItem('guestUser') === 'true';
            if (isGuest) {
                const guestWishlist = JSON.parse(localStorage.getItem('guestWishlist') || '[]');
                const exists = guestWishlist.some((item) => String(item.product_id) === String(productId));
                if (!exists) {
                    guestWishlist.push({
                        _id: `guest-wish-${Date.now()}-${productId}`,
                        product_id: productId,
                        urls: product.urls || [],
                        title: product.title || 'Product',
                        price: product.price,
                        brand: product.brand,
                        mrp: product.mrp,
                        selectedSize: 'M'
                    });
                    localStorage.setItem('guestWishlist', JSON.stringify(guestWishlist));
                }
                setAddedToWishlist(String(productId));
                setTimeout(() => setAddedToWishlist(null), 3000);
                setAddingToWishlist(null);
                return;
            }

            const token = localStorage.getItem("token");
            if (!token) {
                setAddingToWishlist(null);
                return;
            }

            const config = {
                headers: { Authorization: `Bearer ${token}` }
            };

            const response = await axios.post(
                `/products/wish-list/${productId}`,
                {
                    "selectedSize": "M" // Default size, can be made dynamic
                },
                config
            );

            console.log('Add to wishlist response:', response.data);
            setAddedToWishlist(String(productId));
            setTimeout(() => setAddedToWishlist(null), 3000);
            // Refetch profile data to update wishlist count if needed
            try {
                await fetchProfile();
                console.log('Profile data refetched after adding to wishlist');
            } catch (profileError) {
                console.error('Error refetching profile:', profileError);
            }
        } catch (error) {
            console.error('Failed to add to wishlist:', error);
            // Still show tick if item is already in wishlist (400)
            if (error.response?.status === 400) {
                setAddedToWishlist(String(productId));
                setTimeout(() => setAddedToWishlist(null), 3000);
            }
        } finally {
            const elapsed = Date.now() - startedAt;
            const delay = Math.max(0, MIN_LOADER_MS - elapsed);
            if (delay > 0) {
                setTimeout(() => setAddingToWishlist(null), delay);
            } else {
                setAddingToWishlist(null);
            }
        }
    };

    return (
        <div className="product-slider-multi-two-mob">
            {
                slides?.map(({ urls: images, id, title, price, brand, mrp }, index) => {
                    const discount = (mrp != null && price != null && mrp > 0) ? Math.round((1 - price / mrp) * 100) : 0;
                    return (
                        <div className="slide-main">
                            <div className='slide-container'>
                                {
                                    isHover === index ? (
                                        <div className="multi-container" onMouseOver={() => handleDelayChange(images.length)} onMouseLeave={() => unsetHover()} style={isHover === index ? { display: 'block' } : { display: 'none', transition: 'none' }}>

                                            <>
                                                <div
                                                    className="main-multi"
                                                    ref={(el) => {
                                                        if (!el) return;
                                                        mainMultiRefs.current[index] = el;
                                                        if (isHover !== index) {
                                                            el.style.width = '';
                                                            return;
                                                        }
                                                        requestAnimationFrame(() => {
                                                            const w = el.getBoundingClientRect().width;
                                                            el.style.width = Math.round(w) + 'px';
                                                        });
                                                    }}
                                                >
                                                    <div className="multi-slide" style={swichSlides}>
                                                        {
                                                            images.map((image) => {
                                                                return (
                                                                    <div>
                                                                        <img src={image} />
                                                                    </div>
                                                                )
                                                            })
                                                        }
                                                        <div>
                                                            <img src={images?.[0]} />
                                                        </div>
                                                    </div>

                                                    <ul className="slick-smalldots">
                                                        {
                                                            images.map((image, index) => {
                                                                return (
                                                                    <li className={activeSmalldots === index ? 'slick-active' : ''}>
                                                                        <button>{index + 1}</button>
                                                                    </li>
                                                                )
                                                            })
                                                        }
                                                    </ul>
                                                </div>

                                                <div className="multi-meta-data">
                                                    <div className="product-option-container">
                                                        <span className="product-option">
                                                            <span 
                                                                className={`add-to-cart ${addingToCart === id ? 'is-loading' : ''} ${addedToCart === String(id) ? 'is-added' : ''}`}
                                                                onClick={(e) => handleAddToCart({ id, urls: images, title, price, brand, mrp }, e)}
                                                                style={{ 
                                                                    cursor: addingToCart === id ? 'not-allowed' : 'pointer',
                                                                    opacity: addingToCart === id ? 0.8 : 1
                                                                }}
                                                            >
                                                                {addingToCart === id ? (
                                                                    <span className="product-option-loader" aria-hidden />
                                                                ) : addedToCart === String(id) ? (
                                                                    <IoCheckmark size={"1.5em"} />
                                                                ) : (
                                                                    <IoCartOutline size={"1.5em"} />
                                                                )}
                                                            </span>
                                                            <span 
                                                                className={`add-to-wishlist ${addingToWishlist === id ? 'is-loading' : ''} ${addedToWishlist === String(id) ? 'is-added' : ''}`}
                                                                onClick={(e) => handleAddToWishlist({ id, urls: images, title, price, brand, mrp }, e)}
                                                                style={{ 
                                                                    cursor: addingToWishlist === id ? 'not-allowed' : 'pointer',
                                                                    opacity: addingToWishlist === id ? 0.8 : 1
                                                                }}
                                                            >
                                                                {addingToWishlist === id ? (
                                                                    <span className="product-option-loader" aria-hidden />
                                                                ) : addedToWishlist === String(id) ? (
                                                                    <IoCheckmark size={"1.5em"} />
                                                                ) : (
                                                                    < HeartImg width={"1.5em"} height={"1.5em"}/>
                                                                )}
                                                            </span>
                                                        </span>
                                                    </div>
                                                    <div className="brand">{brand ?? '—'}</div>
                                                    <div className="offer-details">
                                                        {price != null && <span>Rs. {price}</span>}
                                                        {mrp != null && mrp > 0 && <span>Rs. {mrp}</span>}
                                                        {discount > 0 && <span>({discount}% OFF)</span>}
                                                    </div>
                                                </div>
                                            </>


                                        </div>

                                    )
                                        :
                                        (
                                            <div className="main-single" onMouseEnter={() => setIsHover(index)} style={isHover !== index ? { display: 'block' }
                                                : { display: 'none', transition: 'none' }} onMouseLeave={() => setIsHover(index)}>
                                                <>
                                                    <div className="ratings-container">
                                                        <span>4.2</span>
                                                        <span>*</span>
                                                        <div className="product-ratingsCount">
                                                            <div className="product-seperator">|</div>
                                                            4.2K
                                                        </div>
                                                    </div>
                                                    <div className="single-slide">
                                                        <img src={newTag} />
                                                        <img src={images?.[0]} />
                                                    </div>

                                                    <div className="multi-meta-data">
                                                        <div className="brand">{brand ?? '—'}</div>
                                                        <div className="title">{title ?? 'Product'}</div>
                                                        <div className="offer-details">
                                                            {price != null && <span>Rs. {price}</span>}
                                                            {mrp != null && mrp > 0 && <span>Rs. {mrp}</span>}
                                                            {discount > 0 && <span>({discount}% OFF)</span>}
                                                        </div>
                                                    </div>
                                                </>
                                            </div>
                                        )
                                }
                            </div>
                        </div>
                    )
                })
            }
        </div>
    )
}